// extracted by mini-css-extract-plugin
module.exports = {"gridAuto":"gridRow_gridAuto__2rsxZ","grid":"gridRow_grid__ase1b"};